'use client';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import Cookies from "js-cookie";
import Config from '../Config';


function Allimageselect({ selectedImageId, setSelectedImageId,uploadedImages,setUploadedImages }) {

  


  const onDrop = async (acceptedFiles) => {
    const newImages = acceptedFiles.map((file, index) => ({
      id: Date.now() + index, // temporary ID
      url: URL.createObjectURL(file),
      uploading: false,
      start:true,
    }));
  
    setUploadedImages((prev) => [...prev, ...newImages]);
  
    setTimeout(() => {
      (async () => {

 
    for (let i = 0; i < acceptedFiles.length; i++) {
      const file = acceptedFiles[i];
      const formData = new FormData();
      formData.append('image', file);
  
      try {
        const res = await axios.post(`${Config.apiurl}/api/v1/common/image-upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data',
             Authorization: `Bearer ${Cookies.get("a_token")}`
           },
        });
  
        setUploadedImages((prev) =>
          prev.map((img) =>
            img.url === newImages[i].url
              ? {
                  id: res.data.data._id,
                  url: res.data.data.fileUrl,
                  uploading: true,
                  start:false,
                }
              : img
          )
        );

        setSelectedImageId((prev) => {
          const exists = prev.some((item) => item.id === res.data.data._id);
          if (!exists) {
            return [...prev, { id: res.data.data._id, url: res.data.data.fileUrl }];
          }
          return prev;
        });

      } catch (error) {
        console.error('Upload failed:', error);
      }
    }

  })();
  },2000)
  };

  

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/webp': ['.webp'],
    },
  });

  const handleSelectImage = (img) => {
    setSelectedImageId((prev) =>
      prev.some((selected) => selected.id === img.id)
        ? prev.filter((selected) => selected.id !== img.id)
        : [...prev, img]
    );
  };

  return (
   
      <div className="w-full input-container_img_div_im mb-2">
      

      
        <div className="d-flex gap-4 flex-wrap ">
    {uploadedImages.map((img) => (
      <div
        key={img.id}
        // onClick={() => handleSelectImage(img)}
        className="image_po"
          style={{
            border: selectedImageId.some((selected) => selected.id === img.id)? '2px solid green' : '2px solid gray',
          padding: '5px',
          cursor: 'pointer',
        }}
        
      >
        <img src={img.url} alt="Uploaded" className="w-full h-full object-cover"  style={{objectFit: 'cover' }}/>

        {/* Loader */}
        {img.start && (
          <div className="image-loader-overlay">
          <div className="spinner" />
          </div>
        )}

        {/* Tick icon */}
        {img.uploading && (
          <div className="upload-success-check">✓</div>
        )}
      </div>
    ))}
  </div>




      </div>
   
  );
}

export default Allimageselect;
